
/*
 * 文件EN: merActivate.js,
 * 文件CN: 商户激活查询列表
 * 创建人: huli
 */
import request from '@/plugins/http'

/**
 * @desc 商户激活查询列表
 * @method GET
 * @param {}
 */
export const getListData = params => {
  return request.get('/merchantActivate/list', params)
}


/**
 * @desc 批量商户激活
 * @method GET
 * @param {}
 */
export const batchUpdate = params => {
  return request.get('/merchantActivate/batchUpdate', params)
}

/**
 * @desc 商户激活
 * @method GET
 * @param {}
 */
export const activate = params => {
  return request.get('/merchantActivate/activate', params)
}
